import { FaSquare } from '@meronex/icons/fa';
import React from 'react';
import { Box } from '@apia/theme';
import {
  TAccordionCellRenderer,
  TAccordionCellRendererProps,
} from './AccordionCell';
import { getPriorityHandler } from './PriorityRenderer';

const PriorityAccordionRenderer: TAccordionCellRenderer = React.forwardRef<
  HTMLTableCellElement,
  TAccordionCellRendererProps
>(({ cell, column, className }, currentRef) => {
  const taskPriorityColor = getPriorityHandler(
    cell.rendererProps?.src as string,
  );
  const title = column?.label ?? column?.name;
  return (
    <Box ref={currentRef} className="priority_container__accordion">
      {title && <Box as="strong">{column?.label ?? column?.name}: </Box>}
      <Box
        as="span"
        className={`priority_accordion ${className ?? ''}`}
        sx={{
          color: taskPriorityColor,
        }}
      >
        <FaSquare />
      </Box>
    </Box>
  );
});

export default PriorityAccordionRenderer;
